<script>

export default {
    name: 'dkbr-tooltip',
    txtDescr: 'Tooltip. Default slot may be used instead of the "text" property',
    props: {
        th: {
            name: 'th',
            type: String,
            enum: ['th1', 'th2', 'th3', 'th4', 'th5', 'th6', 'th7'],
            txtDescr: `Color theme of the element`,
            default: _ => 'th1',
        },
        isThInv: {
            name: 'isThInv',
            type: Boolean,
            txtDescr: `If is true, inversed color theme will be used`,
            default: _ => false,
        },
        text: {
            name: 'text',
            type: String,
            txtDescr: `Text`,
            default: _ => '',
        },
        dir: {
            name: 'dir',
            type: String,
            enum: ['top', 'right', 'bottom', 'left', 'none'],
            txtDescr: `Direction`,
            default: _ => 'bottom',
        },
        dt: {
            name: 'dt',
            type: Number,
            txtDescr: `Delay for tooltip`,
            default: _ => 300,
        },
        isShow: {
            name: 'isShow',
            type: Boolean,
            txtDescr: `Will be shown if true`,
            default: _ => false,
        },
    },
}
</script>

<template lang="pug">

md-tooltip(
    v-if="dir != 'none'"
    :md-theme="isThInv ? th+'i' : th"
    :class=`{'md-primary': true,}`
    :md-direction="dir"
    :md-delay="dt"
    :md-active="isShow")
    slot
        span {{ text }}
</template>



// WEBPACK FOOTER //
// src/tooltip/vue/Tooltip.vue